import type { EditorJsEditorHandle } from './editor';
import type { EditorJsData } from './editorjs-types';
import type { RefObject } from 'react';

import { useCallback } from 'react';

import { EditDocumentEditor } from './editor';

interface ViewDocumentViewerProps {
  editorRef: RefObject<EditorJsEditorHandle | null>;
  documentId?: string;
  isNewDocument: boolean;
  path: string;
  displayPath: string;
  value: EditorJsData | null;
  apiHost: string;
  userEmail: string;
  children: Array<{ id: string; path: string }>;
  onCreateSubpage: () => void;
  /** Navigate to a document path (client-side). Used by Subpages block links. */
  onNavigateToDocument?: (path: string) => void;
}

export function ViewDocumentViewer({
  editorRef,
  documentId,
  isNewDocument,
  path,
  displayPath,
  value,
  apiHost,
  userEmail,
  children,
  onCreateSubpage,
  onNavigateToDocument,
}: ViewDocumentViewerProps) {
  const handleUpload = useCallback(
    async (file: File): Promise<string> => {
      const { uploadImageFile } = await import('./upload-image');
      const result = await uploadImageFile(file, {
        apiHost,
        userEmail,
      });
      return result.url;
    },
    [apiHost, userEmail],
  );

  return (
    <EditDocumentEditor
      key={documentId ?? path}
      ref={editorRef}
      value={value}
      documentId={documentId}
      isNewDocument={isNewDocument}
      onUpload={handleUpload}
      parentPath={displayPath}
      children={children}
      onCreateSubpage={onCreateSubpage}
      onNavigateToDocument={onNavigateToDocument}
    />
  );
}
